module.exports = __webpack_public_path__ + "65c79f652a3da1bf85cbe2a51da03632.MP3";